import styled from 'styled-components';

export default styled('div')`
.CollapsibleText {
  margin: 2rem;
  padding: 1rem;
  border-radius: 10px;

  .row {
    position: relative;
    border-bottom: 1px solid #f0f0f0;

    &:first-of-type {
      border-top: 1px solid #f0f0f0;
    }
  }

  .content {
    height: 0;
    opacity: 0;
    transition: opacity ease-in-out 0.2s;
    overflow: hidden;
    margin-left: 1rem;
  }

  .titleText {
    display: flex;
    padding: 1rem;
    cursor: pointer;
  }

  .defaultWrapper {
    display: flex;

    svg {
      fill: #334b4f;
      transform: rotate(0deg);
      transition: all 0.2s ease-in-out;
    }
  }

  .text {
    margin-left: 1rem;
  }

  input {
    display: none;
  }

  input:checked + .row .content {
    height: auto;
    opacity: 1;
    transition: opacity ease-in-out 0.2s;
    margin-bottom: 1rem;
  }

  input:checked + .row svg {
    transform: rotate(90deg);
  }
}
`